import { SubComponent } from './SubComponent';

export * from './SubComponent';

export default SubComponent;
